// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
if (!customElements.get('sp-community-gallery')) {
  customElements.define('sp-community-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.sp-people__track');
      this.controls = this.querySelector('.sp-people__controls');
      this.cards = [...this.track.children];
      this.count = this.cards.length;
      if (this.count < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const copy = () => this.cards.map(card => {
        const clone = card.cloneNode(true);
        clone.dataset.loopClone = '';
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        clone.querySelectorAll('a').forEach(el => el.tabIndex = -1);
        return clone;
      });
      this.buffers = Math.ceil(5 / this.count);
      this.track.prepend(...Array.from({ length: this.buffers }, copy).flat());
      this.track.append(...Array.from({ length: this.buffers }, copy).flat());
      this.controls.hidden = false;
      this.controls.querySelectorAll('button').forEach(button => {
        button.disabled = false;
        button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options);
      });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('pointerdown', () => { this.dragging = true; this.cancel(); }, options);
      window.addEventListener('pointerup', () => { this.dragging = false; this.settle(); }, options);
      window.addEventListener('pointercancel', () => { this.dragging = false; this.settle(); }, options);
      this.track.addEventListener('wheel', () => { this.cancel(); this.settle(); }, { ...options, passive: true });
      this.track.addEventListener('scroll', () => this.settle(), { ...options, passive: true });
      this.track.addEventListener('scrollend', () => this.finish(), options);
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.track);
      this.resize.observe(this.cards[0]);
      this.measure();
      this.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
        if (!card) return;
        this.cancel();
        this.jump(this.base + this.cards.indexOf(card) * this.step);
      }, options);
    }
    measure() {
      const width = this.track.clientWidth;
      const step = this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
      if (!width || (width === this.width && step === this.step)) return;
      const index = this.step ? (this.track.scrollLeft - this.base) / this.step : 0;
      this.cancel();
      this.width = width;
      this.step = step;
      this.cycle = this.step * this.count;
      this.base = this.buffers * this.cycle;
      this.jump(this.base + ((index % this.count + this.count) % this.count) * this.step);
    }
    jump(position) {
      this.track.scrollTo({ left: position, behavior: 'instant' });
    }
    normalize() {
      if (!this.cycle || this.animating || this.dragging) return;
      const current = this.track.scrollLeft;
      // scrollLeft is rounded by browsers; tolerate subpixel differences at a seam.
      if (current >= this.base - 1 && current < this.base + this.cycle - 1) return;
      // Move by whole cycles only: preserve the visible offset during a loop reset.
      const position = current - Math.floor((current - this.base + 1) / this.cycle) * this.cycle;
      if (Math.abs(position - current) > 1) this.jump(position);
    }
    settle() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.finish(), 160);
    }
    finish() {
      if (this.dragging) return;
      // A scrollend from an interrupted move may arrive after the next click.
      if (this.animating && Math.abs(this.track.scrollLeft - this.target) > 2) return;
      this.animating = false;
      this.normalize();
    }
    cancel() {
      clearTimeout(this.timer);
      if (this.animating) this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'instant' });
      this.animating = false;
    }
    move(direction) {
      if (!this.step) return;
      if (!this.animating) {
        this.normalize();
        this.target = Math.round(this.track.scrollLeft / this.step) * this.step;
      }
      this.animating = true;
      const maximum = Math.floor((this.track.scrollWidth - this.track.clientWidth) / this.step) * this.step;
      this.target = Math.max(0, Math.min(maximum, this.target + direction * this.step));
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.target, behavior: reduced ? 'instant' : 'smooth' });
      this.settle();
    }
    disconnectedCallback() {
      if (this.track) this.cancel();
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      this.track?.querySelectorAll('[data-loop-clone]').forEach(el => el.remove());
      this.width = null;
      this.step = null;
    }
  });
}

